import { SDK } from '../index';
import {
    DailySong,
    DailySongsQueryVariables,
    ResultSuccess,
} from '../generated/graphql';
import { FetchPolicy } from '@apollo/client/core/watchQueryOptions';

export const findManyDailySong = async (
    sdk: SDK,
    fetchPolicy: FetchPolicy = 'cache-first',
): Promise<Array<DailySong> | ResultSuccess> => {
    const query = require('../graphql/queries/dailySongs.query.gql');
    return sdk.query<
        {
            findManyDailySong: Array<DailySong>;
        },
        DailySongsQueryVariables
    >(
        {
            query: query,
            fetchPolicy,
        },
        'findManyDailySong',
    );
};
